import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const API_URL2 = process.env.REACT_APP_API_URL_SOCKET

// ===============================
// SALES AND INVOICES
// ===============================

//get salesinvoices2
export function getSalesInvoicesandsales(user_id: number, start_limit: number, paginationsize: number, start_date: Date , end_date : Date, itemto_order: string, desorasc: string, search_item: string, payment_status: any) {
  return axios.get(`${API_URL}/salesinvoices5`, { params: {user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item, payment_status}})
}

//get salesinvoices payment types
export function getSalesInvoicespaymenttypes(user_id: number, status: string, start_date: Date , end_date : Date, payment_status: any) {
  return axios.get(`${API_URL}/sumpaymenttypes`, { params: {user_id, status, start_date, end_date, payment_status}})
}

//get sumsalesinvoices
export function getSumSalesInvoicesandsales(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number, paginationsize: number) {
  return axios.get(`${API_URL}/sumsalesinvoices`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize}})
}

//submit invoice sales
export function submitInvoiceandSales(allsalesadded: any) {
  return axios.post(`${API_URL}/invoice_sales`, allsalesadded)
}

//delete invoice with sales
export function deleteInvoiceandSales(invoicetodelete: string) {
  return axios.delete(`${API_URL}/deleteinvoiceandsales`, {params:{invoicetodelete}})
}

//update invoice payment
export function updateInvoiceandSales(itemstoupdate: any) {
  return axios.put(`${API_URL}/updateinvoicesales`, {itemstoupdate})
}

// ===============================
// PROFIT AND LOSS ANALYSIS
// ===============================

//get sumprofitorloss
export function getSumProfitorloss(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number) {
  return axios.get(`${API_URL}/sumprofitorloss`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize}})
}

//get grossprofitorloss
export function getGrossProfitorloss(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number) {
  return axios.get(`${API_URL}/grossprofitorloss`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize}})
}

//get daily profit or loss
export function getDailyProfitorloss(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailyprofitorloss`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

//get daily profit or loss (alternative)
export function getDailyProfitorloss2(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailyprofitorloss`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

//get daily sales
export function getDailySales(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailysales`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

//get daily sales (alternative)
export function getDailysales2(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailysales`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

//get variance
export function getVariance(user_id: number, start_date: Date , end_date : Date,start_limit: number,paginationsize: number) {
  return axios.get(`${API_URL}/variance`, {params: {user_id, start_date, end_date, start_limit, paginationsize}})
}

// ===============================
// EXPENSES
// ===============================

//get all expenses
export function getAllexpenses(user_id: number, start_limit: number, paginationsize: number, start_date: Date , end_date : Date, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/allexpenses`, {params : {user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item}})
}

//get daily expenses
export function getDailyexpenses(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailyprofitorloss`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

//get monthly expenses
export function getMonthlyexpenses(user_id: number, start_limit: number, paginationsize: number, start_date: Date , end_date : Date, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailymonthlyexpenses`, {params : {user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item}})
}

//get monthly expenses (alternative)
export function getMonthlyexpenses2(user_id: number, start_limit: number, paginationsize: number, start_date: Date , end_date : Date, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailymonthlyexpenses`, {params : {user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item}})
}

//get expenses summary
export function getSumexpenses(user_id: number, start_date: Date , end_date : Date,start_limit: number,paginationsize: number) {
  return axios.get(`${API_URL}/sumexpenses`, {params: {user_id, start_date, end_date, start_limit, paginationsize}})
}

//add expenses
export function submitExpenses(expenseadded: any) {
  return axios.post(`${API_URL}/expenses`, expenseadded)
}

//update expenses
export function updateExpenses(expensestoupdate: any) {
  return axios.put(`${API_URL}/updateexpenses`, {expensestoupdate})
}

//delete expense
export function deleteExpense(expensetodelete: number) {
  return axios.delete(`${API_URL}/deleteexpense`, {params:{expensetodelete}})
}

//get expense_type
export function getExpenseType() {
  return axios.get(`${API_URL}/expense_type`)
}

//add expense_type
export function submitExpensetype(expensetypeadded: any) {
  return axios.post(`${API_URL}/expensetype`, expensetypeadded)
}

// ===============================
// PRODUCTS AND INVENTORY
// ===============================

//get products
export function getProduct2() {
  return axios.get(`${API_URL}/products2`)
}

//get products with pagination and search
export function getProduct3(start_limit: number, paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/products3`, {params : {start_limit, paginationsize, itemto_order, desorasc, search_item}})
}

//get products (alternative)
export function getProduct4(start_limit: number, paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/products3`, {params : {start_limit, paginationsize, itemto_order, desorasc, search_item}})
}

//get stock summary
export function getStocksum(start_limit: number,paginationsize: number, start_date: Date , end_date : Date) {
  return axios.get(`${API_URL}/stock_sum`, {params:{ start_limit, paginationsize, start_date, end_date}})
}

//get frequently sold
export function getFrequentlysold(paginationsize: number) {
  return axios.get(`${API_URL}/frequentlysold`, {params : {paginationsize}})
}

//get product_unit
export function getProductUnit() {
  return axios.get(`${API_URL}/products_unit`)
}

//get product category
export function getProductCategory() {
  return axios.get(`${API_URL}/products_category`)
}

//add products
export function submitProducts(productadded: any) {
  return axios.post(`${API_URL}/addproducts`, productadded)
}

//update products
export function updateProducts(valuestoupdate: any) {
   return axios.put(`${API_URL}/updateproducts`, {valuestoupdate})
}

//update all products
export function updateallProducts(valuestoupdate: any) {
  return axios.put(`${API_URL}/updateallproducts`, valuestoupdate)
}

//delete product
export function deleteProduct(producttodelete: number) {
  return axios.delete(`${API_URL}/deleteproduct`, {params:{producttodelete}})
}

// ===============================
// STOCK MOVEMENTS
// ===============================

// Get stock movements with filters
export function getStockMovements(
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  product_id?: number,
  movement_type?: string,
  itemto_order?: string,
  desorasc?: string,
  search_item?: string
) {
  return axios.get(`${API_URL}/stock_movements`, {
    params: { user_id, start_limit, paginationsize, start_date, end_date, product_id, movement_type, itemto_order, desorasc, search_item }
  })
}

// Get stock movement summary
export function getStockMovementsSummary(
  user_id: number,
  start_date: Date,
  end_date: Date,
  movement_type?: string
) {
  return axios.get(`${API_URL}/stock_movements_summary`, {
    params: { user_id, start_date, end_date, movement_type }
  })
}

// ===============================
// CASH FLOAT MANAGEMENT
// ===============================

// Get current day's cash float
export function getCashFloat(user_id: number, business_date?: string) {
  return axios.get(`${API_URL}/cashfloat`, { params: { user_id, business_date} })
}

// Get cash float history with pagination and search
export function getCashFloatHistory(user_id: number, start_limit: number, paginationsize: number, start_date: Date, end_date: Date, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/cashfloathistory`, { params: { user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item } })
}

// Open/Create cash float for the day
export function openCashFloat(cashFloatData: any) {
  return axios.post(`${API_URL}/opencashfloat`, cashFloatData)
}

// Close cash float for the day
export function closeCashFloat(cashFloatData: any) {
  return axios.put(`${API_URL}/closecashfloat`, cashFloatData)
}

// Update cash float
export function updateCashFloat(cashFloatData: any) {
  return axios.put(`${API_URL}/updatecashfloat`, cashFloatData)
}

// Delete cash float (Admin only)
export function deleteCashFloat(float_id: number, user_id: number, reason: string) {
  return axios.delete(`${API_URL}/deletecashfloat`, { params: { float_id, user_id, reason } })
}

// Get cash float summary/dashboard
export function getCashFloatSummary(user_id: number, start_date: Date, end_date: Date) {
  return axios.get(`${API_URL}/cashfloatsummary`, { params: { user_id, start_date, end_date } })
}

// Get cash float audit log (Admin only)
export function getCashFloatAudit(user_id: number, start_limit: number, paginationsize: number, start_date: Date, end_date: Date) {
  return axios.get(`${API_URL}/cashfloataudit`, { params: { user_id, start_limit, paginationsize, start_date, end_date } })
}

// Get today's cash float specifically
export function getTodaysCashFloat(user_id: number) {
  const today = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD
  return getCashFloat(user_id, today)
}

// Get cash float by specific date
export function getCashFloatByBusinessDate(user_id: number, business_date: string) {
  return getCashFloat(user_id, business_date)
}

// Quick check if float exists for today
export function checkTodaysFloat(user_id: number) {
  return getTodaysCashFloat(user_id)
}

// ===============================
// PURCHASES AND PROCUREMENT
// ===============================

// Get all purchases with pagination, search, and filters
export function getPurchases(
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) {
  return axios.get(`${API_URL}/purchases`, {
    params: { user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item}
  })
}

// Alternative purchase functions (maintaining backwards compatibility)
export function getAllpurchases(user_id: number, start_limit: number, paginationsize: number, start_date: Date , end_date : Date, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/purchases`, {params : {user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item}})
}

export function getAllpurchases2(user_id: number, start_limit: number, paginationsize: number, start_date: Date , end_date : Date, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/purchases`, {params : {user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item}})
}

// Get single purchase by ID
export function getPurchaseById(user_id: number, purchase_id: number) {
  return axios.get(`${API_URL}/purchases/${purchase_id}`, { params: { user_id } })
}

// Create new purchase with items
export function createPurchase(purchaseData: any) {
  return axios.post(`${API_URL}/purchases`, purchaseData)
}

// Update purchase (e.g., receive purchase)
export function updatePurchase(purchase_id: number, updateData: any) {
  return axios.put(`${API_URL}/purchases/${purchase_id}`, updateData)
}

// Delete purchase
export function deletePurchase(purchase_id: number, user_id: number) {
  return axios.delete(`${API_URL}/purchases/${purchase_id}`, { params: { user_id } })
}

export function deletePurchaseItem(purchase_item_id: number, user_id: number) {
  return axios.delete(`${API_URL}/purchase-items/${purchase_item_id}`, { 
    params: { user_id } 
  })
}
// Get purchases summary
export function getSumPurchases(user_id: number, status: string, start_date: Date , end_date : Date,start_limit: number,paginationsize: number) {
  return axios.get(`${API_URL}/sumpurchases`, {params: {user_id, status, start_date, end_date, start_limit, paginationsize}})
}

// ===============================
// SUPPLIER MANAGEMENT - COMPLETE OPERATIONS
// ===============================

// Get all suppliers with pagination, sorting, search, and optional outstanding payment info
export function getSuppliers(
  user_id: number,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  include_outstanding: boolean = false
) {
  return axios.get(`${API_URL}/suppliers`, {
    params: { 
      user_id, 
      start_limit, 
      paginationsize, 
      itemto_order, 
      desorasc, 
      search_item,
      include_outstanding
    }
  })
}

// Get single supplier by ID with optional purchase details
export function getSupplierById(
  user_id: number, 
  supplier_id: number,
  include_purchases: boolean = false
) {
  return axios.get(`${API_URL}/suppliers/${supplier_id}`, { 
    params: { 
      user_id,
      include_purchases
    } 
  })
}

// Create new supplier
export function createSupplier(supplierData: {
  supplier_firstname: string;
  supplier_secondname: string;
  supplier_phone_number?: string;
  supplier_email?: string;
  supplier_payment_details?: string;
  supplier_company_name?: string;
  supplier_address?: string;
  user_id: number;
}) {
  return axios.post(`${API_URL}/suppliers`, supplierData)
}

// Update supplier
export function updateSupplier(supplier_id: number, updateData: {
  supplier_firstname?: string;
  supplier_secondname?: string;
  supplier_phone_number?: string;
  supplier_email?: string;
  supplier_payment_details?: string;
  supplier_company_name?: string;
  supplier_address?: string;
  user_id: number;
}) {
  return axios.put(`${API_URL}/suppliers/${supplier_id}`, updateData)
}

// Delete supplier
export function deleteSupplier(supplier_id: number, user_id: number) {
  return axios.delete(`${API_URL}/suppliers/${supplier_id}`, { 
    params: { user_id } 
  })
}

// Get suppliers analytics/summary - matches the backend sumsuppliers endpoint
export function getSuppliersSummary(
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number = 0,
  paginationsize: number = 10,
  payment_status: string = '%'
) {
  return axios.get(`${API_URL}/sumsuppliers`, {
    params: {
      user_id,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      payment_status
    }
  })
}

// ===============================
// SUPPLIER UTILITY FUNCTIONS
// ===============================

// Get suppliers with outstanding payments only
export function getSuppliersWithOutstandingPayments(
  user_id: number,
  start_limit: number = 0,
  paginationsize: number = 10,
  search_item: string = ''
) {
  return getSuppliers(
    user_id, 
    start_limit, 
    paginationsize, 
    'supplier_id', 
    'DESC', 
    search_item, 
    true
  )
}

// Get supplier details with all purchase information
export function getSupplierFullDetails(user_id: number, supplier_id: number) {
  return getSupplierById(user_id, supplier_id, true)
}

// ===============================
// SUPPLIER PAYMENTS
// ===============================

// Get supplier payments with filters
export function getSupplierPayments(
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) {
  return axios.get(`${API_URL}/supplier_payments`, {
    params: { user_id, start_limit, paginationsize, start_date, end_date, itemto_order, desorasc, search_item }
  })
}

// Create supplier payment
export function createSupplierPayment(paymentData: any) {
  return axios.post(`${API_URL}/supplier_payments`, paymentData)
}

// Update supplier payment
export function updateSupplierPayment(payment_id: number, updateData: any) {
  return axios.put(`${API_URL}/supplier_payments/${payment_id}`, updateData)
}

// Delete supplier payment
export function deleteSupplierPayment(payment_id: number, user_id: number) {
  return axios.delete(`${API_URL}/supplier_payments/${payment_id}`, { params: { user_id } })
}

// ===============================
// CUSTOMER MANAGEMENT - COMPLETE OPERATIONS
// ===============================

//get customers (legacy function)
export function getCustomers() {
  return axios.get(`${API_URL}/customer`)
}

// Get all customers with pagination, sorting, search, and optional unpaid amounts
export function getCustomers2(
  user_id: number,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  include_unpaid: boolean = false
) {
  return axios.get(`${API_URL}/customers`, {
    params: { 
      user_id, 
      start_limit, 
      paginationsize, 
      itemto_order, 
      desorasc, 
      search_item,
      include_unpaid
    }
  });
}

// Get single customer by ID with optional invoice details
export function getCustomerById(
  user_id: number, 
  customer_id: number,
  include_invoices: boolean = false
) {
  return axios.get(`${API_URL}/customers/${customer_id}`, { 
    params: { 
      user_id,
      include_invoices
    } 
  });
}

// Create new customer
export function createCustomer(customerData: {
  customer_firstname: string;
  customer_secondname: string;
  customer_phone_number?: string;
  customer_email?: string;
  user_id: number;
}) {
  return axios.post(`${API_URL}/customers`, customerData);
}

// Update customer
export function updateCustomer(customer_id: number, updateData: {
  customer_firstname?: string;
  customer_secondname?: string;
  customer_phone_number?: string;
  customer_email?: string;
  user_id: number;
}) {
  return axios.put(`${API_URL}/customers/${customer_id}`, updateData);
}

// Delete customer
export function deleteCustomer(customer_id: number, user_id: number) {
  return axios.delete(`${API_URL}/customers/${customer_id}`, { 
    params: { user_id } 
  });
}

// Get customers summary grouped by date with payment statistics
export function getCustomersSummary(
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number = 0,
  paginationsize: number = 10,
  status: string = '%'
) {
  return axios.get(`${API_URL}/sumcustomers`, {
    params: {
      user_id,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      status
    }
  });
}

// Get top customers by various metrics
export function getTopCustomers(
  user_id: number,
  start_date: string,
  end_date: string,
  limit: number = 10,
  sort_by: 'total_sales' | 'unpaid_amount' | 'invoice_count' = 'total_sales'
) {
  return axios.get(`${API_URL}/topcustomers`, {
    params: {
      user_id,
      start_date,
      end_date,
      limit,
      sort_by
    }
  });
}

// ===============================
// CUSTOMER UTILITY FUNCTIONS
// ===============================

// Get customers with unpaid amounts only
export function getCustomersWithUnpaidAmounts(
  user_id: number,
  start_limit: number = 0,
  paginationsize: number = 10,
  search_item: string = ''
) {
  return getCustomers2(
    user_id, 
    start_limit, 
    paginationsize, 
    'customer_id', 
    'DESC', 
    search_item, 
    true
  );
}

// Get customer details with all invoice information
export function getCustomerFullDetails(user_id: number, customer_id: number) {
  return getCustomerById(user_id, customer_id, true);
}

// Get customers sorted by unpaid amounts (highest first)
export function getCustomersByUnpaidAmount(
  user_id: number,
  start_date: string,
  end_date: string,
  limit: number = 20
) {
  return getTopCustomers(user_id, start_date, end_date, limit, 'unpaid_amount');
}

// Get most active customers by invoice count
export function getMostActiveCustomers(
  user_id: number,
  start_date: string,
  end_date: string,
  limit: number = 10
) {
  return getTopCustomers(user_id, start_date, end_date, limit, 'invoice_count');
}

// ===============================
// USERS AND AUTHENTICATION
// ===============================

//get userrole
export function getUserrole(user_role_id: number) {
  return axios.get(`${API_URL}/userroles`, { params: {user_role_id}})
}

// ===============================
// PAYMENT PROCESSING
// ===============================

//payment_type
export function getPaymentType() {
  return axios.get(`${API_URL}/payment_type`)
}

//payment request
export function paymentRequest(requestdetails: any) {
  return axios.post(`${API_URL2}/27mirrors/paymentrequest`, requestdetails)
}

//transaction status request
export function statusRequest(statusdetails: any) {
  return axios.post(`${API_URL2}/27mirrors/statusrequest`, statusdetails)
}

//get mpesa balance
export function getMpesaBalance() {
  return axios.get(`${API_URL2}/27mirrors/getmpesabalance`)
}

//get daily mpesa transactions
export function getDailyMpesaTransactions(start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailympesatransactions`, {params: {start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

export function getDailyMpesaTransactions2(start_date: Date , end_date : Date,start_limit: number,paginationsize: number, itemto_order: string, desorasc: string, search_item: string) {
  return axios.get(`${API_URL}/dailympesatransactions`, {params: {start_date, end_date, start_limit, paginationsize,itemto_order, desorasc, search_item}})
}

// ===============================
// TYPE DEFINITIONS
// ===============================

// Supplier Type Definitions
export interface Supplier {
  supplier_id: number;
  supplier_firstname: string;
  supplier_secondname: string;
  supplier_name: string;
  supplier_phone_number?: string;
  supplier_email?: string;
  supplier_payment_details?: string;
  supplier_company_name?: string;
  supplier_address?: string;
  total_purchase_amount?: number;
  total_amount_paid?: number;
  total_balance_due?: number;
  fully_paid_amount?: number;
  credit_amount?: number;
  partial_amount?: number;
  overdue_amount?: number;
  total_purchases?: number;
  paid_purchases_count?: number;
  credit_purchases_count?: number;
  partial_purchases_count?: number;
  overdue_purchases_count?: number;
  last_purchase_date?: string;
  first_purchase_date?: string;
  outstanding_purchases?: OutstandingPurchase[];
}

export interface OutstandingPurchase {
  purchase_id: number;
  purchase_number: string;
  total_amount: number;
  amount_paid: number;
  balance_due: number;
  payment_status: string;
  payment_terms?: string;
  due_date?: string;
  purchase_date: string;
  notes?: string;
  status: string;
  created_by_user: string;
}

export interface SupplierSummary {
  date_recordednow: string;
  date_start: string;
  date_end: string;
  total_purchases: number;
  unique_suppliers: number;
  hours_purchasing: number;
  total_purchase_amount: number;
  total_amount_paid: number;
  total_unpaid_amount: number;
  fully_paid_amount: number;
  total_unpaid_credit: number;
  total_unpaid_partial: number;
  total_overdue_amount: number;
  fully_paid_count: number;
  credit_count: number;
  partial_count: number;
  overdue_count: number;
  average_purchase_amount: number;
  highest_purchase_amount: number;
  lowest_purchase_amount: number;
}

// Customer Type Definitions
export interface Customer {
  customer_id: number;
  customer_firstname: string;
  customer_secondname: string;
  customer_name: string;
  customer_phone_number?: string;
  customer_email?: string;
  total_sales_amount?: number;
  total_amount_paid?: number;
  total_unpaid_amount?: number;
  total_invoices?: number;
  unpaid_invoices_count?: number;
  last_sale_date?: string;
  first_sale_date?: string;
  unpaid_invoices?: UnpaidInvoice[];
}

export interface UnpaidInvoice {
  invoice_id: string;
  total_amount: number;
  amount_tendered: number;
  unpaid_amount: number;
  date_recorded: string;
  status: string;
  payment_type_name: string;
  created_by_user: string;
}

export interface CustomerSummary {
  date_recordednow: string;
  date_start: string;
  date_end: string;
  total_invoices: number;
  unique_customers: number;
  hours_selling: number;
  total_sales_amount: number;
  total_amount_tendered: number;
  total_unpaid_amount: number;
  fully_paid_amount: number;
  partially_paid_amount: number;
  unpaid_amount: number;
  fully_paid_count: number;
  partially_paid_count: number;
  unpaid_count: number;
  average_invoice_amount: number;
  highest_invoice_amount: number;
  lowest_invoice_amount: number;
}

export interface TopCustomer {
  customer_id: number;
  customer_firstname: string;
  customer_secondname: string;
  customer_name: string;
  customer_phone_number?: string;
  customer_email?: string;
  total_invoices: number;
  total_sales_amount: number;
  total_amount_paid: number;
  total_unpaid_amount: number;
  unpaid_invoices_count: number;
  average_invoice_amount: number;
  first_sale_date: string;
  last_sale_date: string;
}

// Purchase Type Definitions
export interface Purchase {
  purchase_id: number;
  purchase_number: string;
  supplier_id: number;
  supplier_name: string;
  total_amount: number;
  amount_paid: number;
  balance_due: number;
  payment_status: 'PAID' | 'CREDIT' | 'PARTIAL' | 'OVERDUE';
  payment_terms?: string;
  due_date?: string;
  purchase_date: string;
  received_date?: string;
  notes?: string;
  status: 'PENDING' | 'RECEIVED' | 'CANCELLED';
  created_by_user: string;
  purchase_items?: PurchaseItem[];
}

export interface PurchaseItem {
  purchase_item_id: number;
  purchase_id: number;
  product_id: number;
  product_name: string;
  quantity_ordered: number;
  quantity_received: number;
  unit_cost: number;
  total_cost: number;
  expiry_date?: string;
  batch_number?: string;
}

// Response Type Definitions
export interface SupplierApiResponse {
  suppliers: Supplier[];
  datalength: number;
}

export interface CustomerApiResponse {
  customers: Customer[];
  datalength: number;
  pagination?: {
    current_page: number;
    per_page: number;
    total_records: number;
    total_pages: number;
  };
}

export interface TopCustomersResponse {
  top_customers: TopCustomer[];
  period: {
    start_date: string;
    end_date: string;
    sorted_by: string;
    limit_applied: number;
  };
}

export interface PurchaseApiResponse {
  purchases: Purchase[];
  datalength: number;
}

// ===============================
// ERROR HANDLING UTILITIES
// ===============================

// Error handling wrapper for customer operations
export async function safeCustomerOperation<T>(
  operation: () => Promise<T>,
  errorContext: string = 'Customer operation'
): Promise<{ success: boolean; data?: T; error?: string }> {
  try {
    const data = await operation();
    return { success: true, data };
  } catch (error: any) {
    console.error(`${errorContext} failed:`, error);
    
    // Handle common API errors
    if (error.response?.status === 401) {
      return { success: false, error: 'User not found or unauthorized' };
    } else if (error.response?.status === 403) {
      return { success: false, error: 'Access denied - admin privileges required' };
    } else if (error.response?.status === 404) {
      return { success: false, error: 'Customer not found' };
    } else if (error.response?.status === 409) {
      return { success: false, error: error.response.data?.error || 'Conflict - customer already exists or has dependencies' };
    } else if (error.response?.data?.error) {
      return { success: false, error: error.response.data.error };
    } else {
      return { success: false, error: 'An unexpected error occurred' };
    }
  }
}

// Error handling wrapper for supplier operations
export async function safeSupplierOperation<T>(
  operation: () => Promise<T>,
  errorContext: string = 'Supplier operation'
): Promise<{ success: boolean; data?: T; error?: string }> {
  try {
    const data = await operation();
    return { success: true, data };
  } catch (error: any) {
    console.error(`${errorContext} failed:`, error);
    
    // Handle common API errors
    if (error.response?.status === 401) {
      return { success: false, error: 'User not found or unauthorized' };
    } else if (error.response?.status === 403) {
      return { success: false, error: 'Access denied - admin privileges required' };
    } else if (error.response?.status === 404) {
      return { success: false, error: 'Supplier not found' };
    } else if (error.response?.status === 409) {
      return { success: false, error: error.response.data?.error || 'Conflict - supplier already exists or has dependencies' };
    } else if (error.response?.data?.error) {
      return { success: false, error: error.response.data.error };
    } else {
      return { success: false, error: 'An unexpected error occurred' };
    }
  }
}

// Error handling wrapper for purchase operations
export async function safePurchaseOperation<T>(
  operation: () => Promise<T>,
  errorContext: string = 'Purchase operation'
): Promise<{ success: boolean; data?: T; error?: string }> {
  try {
    const data = await operation();
    return { success: true, data };
  } catch (error: any) {
    console.error(`${errorContext} failed:`, error);
    
    // Handle common API errors
    if (error.response?.status === 401) {
      return { success: false, error: 'User not found or unauthorized' };
    } else if (error.response?.status === 403) {
      return { success: false, error: 'Access denied - admin privileges required' };
    } else if (error.response?.status === 404) {
      return { success: false, error: 'Purchase not found' };
    } else if (error.response?.status === 409) {
      return { success: false, error: error.response.data?.error || 'Conflict - purchase has dependencies or validation failed' };
    } else if (error.response?.data?.error) {
      return { success: false, error: error.response.data.error };
    } else {
      return { success: false, error: 'An unexpected error occurred' };
    }
  }
}

// Generic error handler for any API operation
export async function safeApiOperation<T>(
  operation: () => Promise<T>,
  errorContext: string = 'API operation'
): Promise<{ success: boolean; data?: T; error?: string }> {
  try {
    const data = await operation();
    return { success: true, data };
  } catch (error: any) {
    console.error(`${errorContext} failed:`, error);
    
    // Handle common API errors
    if (error.response?.status === 401) {
      return { success: false, error: 'Authentication failed or user not found' };
    } else if (error.response?.status === 403) {
      return { success: false, error: 'Access denied - insufficient privileges' };
    } else if (error.response?.status === 404) {
      return { success: false, error: 'Resource not found' };
    } else if (error.response?.status === 409) {
      return { success: false, error: error.response.data?.error || 'Conflict - resource already exists or has dependencies' };
    } else if (error.response?.status === 400) {
      return { success: false, error: error.response.data?.error || 'Invalid request data' };
    } else if (error.response?.status >= 500) {
      return { success: false, error: 'Server error - please try again later' };
    } else if (error.response?.data?.error) {
      return { success: false, error: error.response.data.error };
    } else if (error.message) {
      return { success: false, error: error.message };
    } else {
      return { success: false, error: 'An unexpected error occurred' };
    }
  }
}